import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

// Masked line-by-line text reveal. Pass an array of strings via `lines`.
export const LineReveal = ({ lines = [], className = "", delay = 0, lineClassName = "", testId }) => (
  <span className={className} data-testid={testId}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden">
        <motion.span
          className={`block ${lineClassName}`}
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1.1, ease, delay: delay + i * 0.12 }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

// Generic scroll-triggered reveal wrapper.
export const Reveal = ({ children, className = "", delay = 0, y = 40, once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-80px" }}
    transition={{ duration: 0.9, ease, delay }}
  >
    {children}
  </motion.div>
);

// Masked single-line reveal triggered on scroll.
export const LineRevealOnView = ({ text, className = "", delay = 0, once = true }) => (
  <span className="block overflow-hidden">
    <motion.span
      className={`block ${className}`}
      initial={{ y: "110%" }}
      whileInView={{ y: "0%" }}
      viewport={{ once, margin: "-60px" }}
      transition={{ duration: 1, ease, delay }}
    >
      {text}
    </motion.span>
  </span>
);
